export const ColorMode = {
  Sw: 100,
  Color: 200
}
